import React from "react"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import {H3} from "@irati/ui/src/Typography/Heading"

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${({theme}) => theme.spacing.four} 0 ${({theme}) => theme.spacing.one};
`

const PollsTitle = () => {
  return (
    <HeaderWrapper>
      <H3>
        <FormattedMessage id="recognition.polls.banner.title" />
      </H3>
    </HeaderWrapper>
  )
}

export default PollsTitle
